export enum BreadcrumbTypesEnum {
	ChartList = 'chartList',
	Dashboard = 'dashboard',
}
